import { DuplicateIcon, PasteIcon, PasteInsideIcon, ScissorIcon } from 'canoe';
import React, { Fragment } from 'react';

import { useEventing } from 'commons/eventing';
import { InsertMode, useCopyCutAndPaste } from 'craft/hooks';

import { MenuItem } from './MenuItem';
import { useOnCloseMenu } from './useOnCloseMenu';

export const CopyCutAndPaste = () => {
  const { track } = useEventing();
  const onCloseMenu = useOnCloseMenu();
  const { onCopy, canCopy, onCut, canCut, onPaste, canPaste, canPasteInto } = useCopyCutAndPaste();

  const isCopyDisabled = !canCopy();
  const isPasteDisabled = !canPaste();
  const isPasteIntoDisabled = !canPasteInto();
  const isCutDisabled = !canCut();

  return (
    <Fragment>
      <MenuItem
        onClick={() => {
          track('editor.click.copy', { category: 'contextMenu' });
          onCopy();
          onCloseMenu();
        }}
        enabled={!isCopyDisabled}
        icon={<DuplicateIcon color={isCopyDisabled ? 'OnyxGrayL20' : 'White'} />}
        shortcuts={['mod', 'C']}
      >
        Copy
      </MenuItem>
      <MenuItem
        onClick={() => {
          track('editor.click.cut', { category: 'contextMenu' });
          onCut();
          onCloseMenu();
        }}
        enabled={!isCutDisabled}
        icon={<ScissorIcon color={isCutDisabled ? 'OnyxGrayL20' : 'White'} />}
        shortcuts={['mod', 'X']}
      >
        Cut
      </MenuItem>
      <MenuItem
        onClick={() => {
          track('editor.click.paste', { category: 'contextMenu' });
          onPaste();
          onCloseMenu();
        }}
        enabled={!isPasteDisabled}
        icon={<PasteIcon color={isPasteDisabled ? 'OnyxGrayL20' : 'White'} />}
        shortcuts={['mod', 'V']}
      >
        Paste
      </MenuItem>
      <MenuItem
        onClick={() => {
          track('editor.click.pasteInto', { category: 'contextMenu' });
          onPaste(InsertMode.INTO);
          onCloseMenu();
        }}
        enabled={!isPasteIntoDisabled}
        icon={<PasteInsideIcon color={isPasteIntoDisabled ? 'OnyxGrayL20' : 'White'} />}
        shortcuts={['shift', 'mod', 'V']}
      >
        Paste Into
      </MenuItem>
    </Fragment>
  );
};
